export const environment = {
  production: true,
  backOfficeURL: 'https://app-breello-dev.fromscratch-apis.com',
  hotjarTrackingId: '2372128',
};
